
import { defineComponent, inject, ref, computed, provide } from 'vue'
import axios from "axios";
//icons
import { Search, ArrowLeft } from '@element-plus/icons-vue'
//components
import MixedWidget1 from "@/components/widgets/mixed/Widget1.vue";
import MixedWidget14 from "@/components/widgets/mixed/Widget14.vue";
import ModalSelectPerson from "@/components/modals/general/ModalListPersons.vue";
import ModalRegister from "./ModalRegister.vue"
import ModalTest from "@/components/modals/general/ModalTest.vue"
import ModalTeamColor from "./ModalTeamColor.vue"
import ModalObservaciones from './ModalObservaciones.vue';
import CountDown from "@/components/widgets/mixed/dsCounter.vue"
import ModalTenisMesa from './ModalTenisMesa.vue';
//services
import eventService from "@/core/services/EventService";
import AcrdService from '@/core/services/AcrdService';
import { errManager, mbtoa } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";
import moment from 'moment';
moment.locale("es");
import FileService from "@/core/services/FileService";
import sFiles from "@/components/wizard/steps/sFiles.vue"

export default defineComponent({
    props: {
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        sport: {
            type: Object,
            required: true,
            default: {}
        },
        listStatus: {
            type: null,
            required: true,
            default: []
        }
    },
    components: {
        MixedWidget1, MixedWidget14, ModalSelectPerson, ModalRegister,
        ModalTeamColor, ModalObservaciones, ModalTest, CountDown, sFiles,
        ModalTenisMesa
    },
    setup(props) {
        let fURL;
        const { t } = useI18n();
        const altura = screen.height - 350;
        const isTerminos = ref(false)
        const repo = ref(process.env.VUE_APP_REPO)
        const action = ref(0)
        const dialogNominal = inject<boolean>('dialogNominal')
        const dialogTeamColor = ref(false)
        const dialogTerminos = ref(false)
        const listRTRegister = ref<any>([])
        const listRCheckDoc = ref<any>([])
        const listRGender = ref<any>([])
        const listNominal = ref<any>([])
        const total = ref(0)
        const loaderGral = ref(false)
        const loaderSumary = ref<any>(false)
        const loaderTable = ref(false)
        const loaderDownload = ref(false)
        const fechaFin = ref<Date | null>(null)
        const multipleSelection = ref<any[]>([])
        const ModalTenisMesaRef = ref<any>(null);

        const searchText = ref("")
        const tregister = ref("D")
        const listChecks = ref<any>([])
        const gblDialogAcrd = ref<any>(false) //modal register
        const gblDialogTest = ref<any>(false)
        const listSetting = ref<any>({}) //lista de configuraciones
        const closure = ref<any>({})
        //get data sharing
        const gblDialog = inject<any>('gblDialog')
        const gblRowAcrd = inject<any>('gblRowAcrd')
        const dialogObservation = ref(false)
        const rowIdObs = ref<any>('')

        const rowAcrd = ref<any>({})

        const dialogDocumentation = ref(false)
        const listTypeFile = ref<any[]>([])

        provide('gblDialogAcrd', gblDialogAcrd)
        provide('gblDialogTest', gblDialogTest)
        provide('dialogTeamColor', dialogTeamColor)
        provide('rowAcrd', rowAcrd)
        provide('dialogObservation', dialogObservation)
        provide('rowIdObs', rowIdObs)
        provide("listTypeFile", listTypeFile)

        //methods
        const onOpened = () => {
            //typeRegister.value = (props.sport.idsport == 18) ? "OA" : "D"
            setStatus()
            //tregister.value = "D"
            //getSummary()
            //getListNominal()
            getSetting()
        }

        const getSetting = async () => {
            loaderGral.value = true
            await AcrdService.options('setting', { idevent: props.evento.idevent, idsport: props.sport.idsport })
                .then((res) => {
                    loaderGral.value = false
                    listSetting.value = res.data
                    closure.value = res.data.closure
                    fechaFin.value = closure.value.date_end
                    tregister.value = res.data.tregister[0]?.id
                    getSummary()
                    getListNominal()
                }).catch(({ response }) => {
                    loaderGral.value = false
                    errManager(response)
                })
        }

        const setStatus = () => {
            if (listChecks.value.length == 0) {
                listChecks.value.length = 0
                props.listStatus.forEach((element: any) => {
                    listChecks.value.push(element.id)
                });
            }
        }

        const onClosed = () => {
            total.value = 0
            listNominal.value = []
            listRCheckDoc.value = []
            listRGender.value = []
            listRTRegister.value = []
            listSetting.value = {}
            closure.value = {}
            loaderGral.value = false
        }

        //resumen
        const getSummary = async () => {
            loaderSumary.value = true
            listRTRegister.value = []
            listRCheckDoc.value = []
            listRGender.value = []
            total.value = 0
            listRGender.value.slice(0)
            await eventService.summary({
                idevent: props.evento?.idevent,
                idsport: props.sport.idsport,
                checkdoc: [0, 1, 2, 3, 4]
            })
                .then((res) => {
                    listRTRegister.value = res.data.rtregister
                    listRCheckDoc.value = res.data.rcheckdoc
                    listRGender.value = res.data.rgender
                    listRGender.value.forEach(element => {
                        total.value += parseInt(element.quantity)
                    });
                    loaderSumary.value = false
                }).catch(({ response }) => {
                    loaderSumary.value = false
                    errManager(response)
                })
        }

        const getListNominal = async () => {
            listNominal.value.length = 0
            loaderTable.value = true
            await eventService.getNominal({
                idevent: props.evento.idevent,
                idsport: props.sport.idsport,
                checkdoc: listChecks.value,
                type_register: tregister.value,
            })
                .then((res) => {
                    listNominal.value = res.data
                    loaderTable.value = false
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        //filters
        const filteredNominal = computed(() => {
            return listNominal.value.filter(
                (item) =>
                    item.persona.toLowerCase().includes(searchText.value.toLowerCase()) ||
                    item.docnumber.includes(searchText.value.toLowerCase())
            );
        });

        const openModalSelectPersons = () => {
            gblDialog.value = true
        }

        const getSelectRow = (data) => {
            Object.assign(rowAcrd.value, data, { tregister: tregister }, { idevent: props.evento.idevent }, { idsport: props.sport.idsport })
            action.value = 1
            gblDialogAcrd.value = true
        }

        const OnTest = async (row) => {
            loaderTable.value = true
            await AcrdService.getAcreditation(row.idacreditation, 'show')
                .then((res) => {
                    loaderTable.value = false
                    Object.assign(rowAcrd.value, res.data.info)
                    gblDialogTest.value = true
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        const onEdit = async (row, accion) => {
            loaderTable.value = true
            await AcrdService.getAcreditation(row.idacreditation, 'show')
                .then((res) => {
                    loaderTable.value = false
                    Object.assign(rowAcrd.value, res.data.info)
                    action.value = accion
                    gblDialogAcrd.value = true
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })

            //Object.assign(row)
            //action.value = accion
            //gblDialogAcrd.value = true
        }

        const onDelete = (row) => {
            Swal.fire({
                title: t('deleteRecord'),
                html: `¿Desea eliminar al participante <b>${row.firstname} ${row.lastname}</b> de la lista nominal?`,
                icon: 'question',
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                },
                showCancelButton: true,
                confirmButtonText: t('delete'),
                cancelButtonText: t('cancel'),
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return AcrdService.delete(row.idacreditation)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        icon: result.value.status,
                        title: result.value.title,
                        html: result.value.message
                    })
                    if (result.value.status === 'success') {
                        getListNominal()
                        getSummary()
                    }
                    //result.value.status === 'success' && 
                }
            })
        }

        //Descargar reportes Excel
        const DownloadXLSXPDF = (ext, target, payload) => {
            loaderDownload.value = true
            let params = new URLSearchParams(payload);
            axios({
                url: process.env.VUE_APP_API_URL + `/${ext}/${target}?${params}`,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileBlob = new Blob([response.data], { type: response.data.type });

                //var nameFile = moment().format() + "." + ext;
                var contentDisposition = response.headers['content-disposition'];
                var match = /filename="([^"]*)"/.exec(contentDisposition);
                var nameFile = match && match[1] ? match[1] : moment().format() + "." + ext;
                if (!fURL) {
                    fURL = document.createElement('a');
                    fURL.style.display = 'none';
                    document.body.appendChild(fURL);
                }
                var fileURL = window.URL.createObjectURL(fileBlob);
                fURL.href = fileURL;
                fURL.setAttribute('download', nameFile);
                fURL.click();
            }).catch((err) => {
                loaderDownload.value = false
                errManager(err)
            }).finally(() => {
                loaderDownload.value = false;
            });
        }

        const sendDataValidation = () => {
            if (multipleSelection.value.length > 0) {
                dialogTerminos.value = true
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    html: "Para solicitar la revisión de información, necesita seleccionar solo los registros cuyos estados sean <b>Borrador</b> u <b>Observado</b>!",
                });
            }
        }

        const handleSelectionChange = (val: any[]) => {
            multipleSelection.value = []
            val.forEach(item => {
                if (item.hasOwnProperty('checkdoc') && (item.checkdoc == '0' || item.checkdoc == '4')) {
                    multipleSelection.value.push(item);
                }
            });
        }

        const sendVerification = async () => {
            loaderGral.value = true
            dialogTerminos.value = false
            await AcrdService.options('verification', { idevent: btoa(props.evento.idevent), idsport: btoa(props.sport.idsport), data: multipleSelection.value })
                .then((res) => {
                    loaderGral.value = false
                    if (res.data.status == 'true') {
                        getSummary()
                        listNominal()
                    }

                    Swal.fire({
                        icon: res.data.status,
                        title: res.data.title,
                        html: res.data.message
                    })
                }).catch(({ response }) => {
                    loaderGral.value = false
                    errManager(response)
                })
        }

        //metodo de respuesta modal register acrd
        const onResponse = (data) => {
            if (data.status == 'success') {
                getSummary()
                getListNominal()
            }
        }

        const onObservations = (data) => {
            rowIdObs.value = data.idacreditation
            dialogObservation.value = true
        }

        const onViewDocumentation = async (data) => {
            Object.assign(rowAcrd.value, data)
            listTypeFile.value = []
            await FileService.getFiles2('acrd', 'type', { tregister: tregister.value, idevent: rowAcrd.value.idevent, idsport: rowAcrd.value.idsport })
                .then((res) => {
                    listTypeFile.value = res.data
                    dialogDocumentation.value = true
                }).catch(({ response }) => {
                    listTypeFile.value = []
                })
        }

        const onClosedDoc = () => {
            rowAcrd.value = {}
        }

        const openTenisMesa = () => {
            if(ModalTenisMesaRef.value){
                ModalTenisMesaRef.value.openModal();
            }
        };

        const downloadCredential = (row: any) => {
            DownloadXLSXPDF('pdf', `credentials/${row?.idacreditation}/download`, {})
        }

        return {
            //dialog
            t,
            mbtoa,
            fechaFin,
            altura,
            isTerminos,
            action,
            dialogNominal,
            dialogTeamColor,
            dialogTerminos,
            //more
            gblRowAcrd,
            rowAcrd,
            searchText,
            tregister,
            listChecks,
            closure,
            //loaders
            repo, loaderSumary, loaderTable, loaderGral, loaderDownload,
            //icons,
            Search, ArrowLeft,
            //list
            listRTRegister,
            listRCheckDoc,
            listRGender,
            listNominal,
            listSetting,
            total,
            multipleSelection,
            rowIdObs,
            dialogDocumentation,
            ModalTenisMesaRef,

            //methods
            onOpened,
            getSetting,
            onClosed,
            getListNominal,
            filteredNominal,
            openModalSelectPersons,
            getSelectRow,
            onResponse,
            onEdit,
            onDelete,
            DownloadXLSXPDF,
            sendDataValidation,
            handleSelectionChange,
            sendVerification,
            onObservations,
            OnTest,
            onViewDocumentation,
            onClosedDoc,
            openTenisMesa,
            downloadCredential
        }

    },
})
